import { render } from "./VisitPackagesAndMaterials.vue?vue&type=template&id=807c053e"
import script from "./VisitPackagesAndMaterials.vue?vue&type=script&lang=js"
export * from "./VisitPackagesAndMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__